@if (connectionForms().length > 0) {
  <mat-card>
    <mat-card-header class="full-width-header">
      <mat-card-title>
        <div class="title-row">
          <span>{{ 'AI_ASSISTANT.SETTINGS.CHANNELS.TITLE' | translate }}</span>
          @if (connectionForms().dirty) {
            <span class="unsaved-changes-text">
              {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
            </span>
          }
        </div>
      </mat-card-title>
      <mat-card-subtitle>{{ 'AI_ASSISTANT.SETTINGS.CHANNELS.SUBTITLE' | translate }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      @for (connectionForm of connectionForms().controls; track connectionForm) {
        @if (
          (connectionForm.metadata.name !== 'Facebook' && connectionForm.metadata.name !== 'Instagram') || showFBInsta()
        ) {
          <glxy-form-field bottomSpacing="none">
            <mat-checkbox [formControl]="connectionForm.controls.connected" class="connections-checkbox">
              <div class="checkbox-icon-and-label-wrapper">
                <img [src]="connectionForm.metadata.iconUrl" alt="avatar" class="connection-icon" />
                <div>
                  <div>
                    {{ connectionForm.metadata.name }}
                  </div>
                  @if (connectionForm.metadata.cta?.action?.showButton) {
                    <a
                      (click)="triggerAction(connectionForm.metadata); $event.preventDefault()"
                      class="connections-checkbox-settings-link"
                    >
                      @if (connectionForm.metadata.isDefault && !connectionForm.metadata.cta?.label) {
                        {{
                          'AI_ASSISTANT.SETTINGS.SETUP_CONNECTIONS'
                            | translate: { connectionName: connectionForm.metadata.name }
                        }}
                      } @else {
                        {{ connectionForm.metadata.cta?.label || 'AI_ASSISTANT.SETTINGS.SETTINGS' | translate }}
                      }
                    </a>
                  }
                </div>
              </div>
            </mat-checkbox>
          </glxy-form-field>
        }
      }
    </mat-card-content>
  </mat-card>
}
